const Footer = () => {
    return (
        <div>
            <div className="seperator"></div>
            <div className="footer"> Selbon Software ©2022</div>
        </div>
    )
}

export default Footer